import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { ApiConnectionString } from '../../constants/ApiConntection';


export default function ViewImage() {
  
  const { id } = useParams();

  
  return (
    <div>
   
      <img src={`${ApiConnectionString}/api/club/image/${id}`} alt="Club Image" width={200} className='mt-2'/>

  </div>
  );
}